import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { StepProps } from '../../components/OrionRiskToleranceWorkflow/OrionRiskToleranceWorkflow.meta';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { StepId } from '../../api/useRiskToleranceWorkflowQuery';
import { Footer } from '../../components/Footer/Footer';
import { StepCard } from '../../components/StepCard/StepCard';
import { FormValues, options, title } from './RiskLevel.meta';
import { StyledVisualPicker } from './RiskLevel.styles';
import { Content } from '../../components/Content/Content';

export const RiskLevel: React.FC<StepProps> = ({
  answers,
  onPrevious,
  onNext,
  onSubmit,
  progress,
}) => {
  const { handleSubmit, setValue, control } = useForm<FormValues>({
    defaultValues: {
      [StepId.RiskLevel]: answers.riskLevel,
    },
  });

  const onSubmitStep = ({ riskLevel }: FormValues) => {
    onSubmit({ stepId: StepId.RiskLevel, answer: riskLevel });
    onNext();
  };

  return (
    <Box minWidth={1136}>
      <form onSubmit={handleSubmit(onSubmitStep)}>
        <Content>
          <StepCard title={title} width={1104}>
            <Box display="flex" justifyContent="space-between" mb="16">
              <Text variant="smallCaps">Low</Text>

              <Text variant="smallCaps">Medium</Text>

              <Text variant="smallCaps">High</Text>
            </Box>

            <Controller
              control={control}
              name={StepId.RiskLevel}
              render={({ field: { value: formValue } }) => (
                <Box display="flex" gridGap="16" role="radiogroup" aria-label={title}>
                  {options.map(({ label, value }) => {
                    const checked = value === formValue;

                    return (
                      <StyledVisualPicker
                        key={value}
                        label={label}
                        onChange={() => setValue(StepId.RiskLevel, value)}
                        checked={checked}
                      />
                    );
                  })}
                </Box>
              )}
            />
          </StepCard>
        </Content>

        <Footer onPrevious={onPrevious} progress={progress} />
      </form>
    </Box>
  );
};
